import Vue from 'vue'
import App from './App.vue'

import enrutador from './routes'

import './thirdParty'
import './mixins'

Vue.config.productionTip = false

export const eventBus = new Vue();


new Vue({
  router: enrutador,
  render: (h) => h(App),
}).$mount("#app");
